import React, { useState, useEffect } from "react";
import "./customCursor.css";

const CustomCursor = ({ isDefaultCursorPage }) => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [clicked, setClicked] = useState(false);
  const [linkHovered, setLinkHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const addEventListeners = () => {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mousedown", onMouseDown);
      document.addEventListener("mouseup", onMouseUp);
      document.addEventListener("mouseover", onMouseOver);
      document.addEventListener("mouseout", onMouseOut);
      document.addEventListener("mouseleave", onMouseLeave);
      document.addEventListener("mouseenter", onMouseEnter);
    };

    const removeEventListeners = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mouseover", onMouseOver);
      document.removeEventListener("mouseout", onMouseOut);
      document.addEventListener("mouseleave", onMouseLeave);
      document.addEventListener("mouseenter", onMouseEnter);
    };

    const onMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const onMouseDown = () => {
      setClicked(true);
    };

    const onMouseUp = () => {
      setClicked(false);
    };

    const onMouseOver = (e) => {
      const customCursorElement = e.target.closest(".custom-cursor, a, button");
      if (customCursorElement) {
        setLinkHovered(true);
      }
    };

    const onMouseOut = (e) => {
      const customCursorElement = e.target.closest(".custom-cursor, a, button");
      if (
        customCursorElement &&
        !customCursorElement.contains(e.relatedTarget)
      ) {
        setLinkHovered(false);
      }
    };

    const onMouseLeave = () => {
      setIsVisible(false);
    };

    const onMouseEnter = () => {
      setIsVisible(true);
    };

    addEventListeners();
    return () => removeEventListeners();
  }, [isDefaultCursorPage]);

  return (
    isVisible && (
      <>
        <div
          className={`cursor ${clicked ? "cursor--clicked" : ""} ${
            linkHovered ? "cursor--link-hovered" : ""
          }`}
          style={{ left: `${position.x}px`, top: `${position.y}px` }}
        />
        <div
          className={`cursor-border ${
            linkHovered ? "cursor-border--link-hovered" : ""
          }`}
          style={{ left: `${position.x}px`, top: `${position.y}px` }}
        />
      </>
    )
  );
};

export default CustomCursor;
